import React, { useEffect, useState } from 'react'
import { enToPersianChar } from '../../../../../../components/helper'
import CustomValuesHook from '../../../../../../Hooks/customValuesHook'
import request from "../../../../../../service/apiCall"
import { CSpinner } from '@coreui/react'

const CallModal = ({ toNumber, close, setError, setInCall }: { toNumber: string, close: Function, setError: Function, setInCall: Function }) => {
    const [states, setStates] = CustomValuesHook({ fromNumber: '' })
    const [waitforResult, setWaitforResult] = useState(false);
    useEffect(() => {
        let sdParams: any | null = localStorage.getItem("out_going_call_data")
        if (sdParams) {
            sdParams = JSON.parse(sdParams)
            setStates({ fromNumber: sdParams?.first_number, customerLineId: sdParams?.customer_line_id })
        }

    }, [])

    const handleCall = () => {

        if (states.customerLineId) {
            setError()
            setWaitforResult(true);
            request.defaults.baseURL = process.env.REACT_APP_CORE_API_ENDPOINT;
            request.post(`/api/OutgoingCall/OutgoingCall?customerLineId=${states.customerLineId}&firstSideNumber=${states.fromNumber}&secondSideNumber=${toNumber}`)
                .then((response: any) => {
                    setWaitforResult(false);
                    var result: any = JSON.stringify(response);
                    if (result?.response?.status === 200) {
                        setInCall({ from: states.fromNumber, to: toNumber, callSuccess: true })
                    }
                }, (error) => {
                    setWaitforResult(false);
                    setError(error);
                })

                .catch((error) => {
                    setWaitforResult(false);
                    setError('خطا در گرفتن اطلاعات بوجود آمد دوباره تلاش کنید');
                });
        }
    }

    return (
        <div className='call-cantext-back'>
            <div>
                <div>
                    <p>آیا با گرفتن شماره <b>{enToPersianChar(toNumber)}</b>  <br /> از شماره <b>{enToPersianChar(states.fromNumber)}</b> موافق هستید؟</p>
                    <div className='d-flex justify-content-between mt-5'>
                        {waitforResult && <span> <CSpinner /> درحال بررسی</span>}
                        {!waitforResult && <span onClick={handleCall}> بله</span>}
                        <span onClick={() => close()}>بستن</span>

                    </div>
                </div>
            </div>

        </div>
    )
}

export default CallModal